import { render } from "./ProcessElementsPanel.vue?vue&type=template&id=f71a9586&scoped=true"
import script from "./ProcessElementsPanel.vue?vue&type=script&lang=js"
export * from "./ProcessElementsPanel.vue?vue&type=script&lang=js"

import "./ProcessElementsPanel.vue?vue&type=style&index=0&id=f71a9586&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71a9586"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab,QTabPanel});
